import React, { useCallback, useEffect, useRef } from 'react'

import { useEventContext } from 'context/EventContext'

import classes from './ScrollMilestones.module.scss'

const ScrollMilestones = () => {
  const { sendEvent } = useEventContext()
  const refs = useRef([])
  const setRefs = useCallback(node => {
    refs.current.push(node)
  }, [])

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const { target } = entry
        const { percentage, reached } = target.dataset

        if (entry.isIntersecting && !reached) {
          target.dataset.reached = 'true'
          sendEvent({
            name: 'scroll',
            percentScroll: `${percentage}%`,
          })
        }
      })
    })

    refs.current.forEach(ref => {
      observer.observe(ref)
    })

    return () => {
      observer.disconnect()
    }
  }, [sendEvent])
  return (
    <>
      <div ref={setRefs} data-percentage="10" className={classes.p10} />
      <div ref={setRefs} data-percentage="25" className={classes.p25} />
      <div ref={setRefs} data-percentage="50" className={classes.p50} />
      <div ref={setRefs} data-percentage="75" className={classes.p75} />
      <div ref={setRefs} data-percentage="90" className={classes.p90} />
      <div ref={setRefs} data-percentage="100" className={classes.p100} />
    </>
  )
}

export default ScrollMilestones
